import React from 'react';
import { Container, Typography, Box, Grid, Card, CardContent, List, ListItem, ListItemText, Paper, Divider , Button} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Payment } from '@mui/icons-material';

const HerbTea = () => {
  const { t, i18n } = useTranslation();

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          {t('herbtea.title')}
          
        </Typography>
        <Typography variant="h5" gutterBottom>
          {t('herbtea.subtitle')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('herbtea.description')}
        </Typography>
        
         {/* Add the herbal tea image */}
         <Box 
          component="img"
          src="/images/herbtea.png"
          alt="Chinese Herbal Tea"
          sx={{
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '400px',
            my: 3,
            borderRadius: '8px',
            boxShadow: 3
          }}
        />

        <Box sx={{ my: 4 }}>
          <List>
            {Array.isArray(t('herbtea.benefits', { returnObjects: true })) 
              ? t('herbtea.benefits', { returnObjects: true }).map((benefit, index) => (
                <ListItem key={index}>
                  <ListItemText primary={benefit} />
                </ListItem>
              ))
              : <ListItem><ListItemText primary={t('herbtea.benefits')} /></ListItem>
            }
          </List>
        </Box>
      </Box>

      <Paper elevation={3} sx={{ p: 4, mb: 6, bgcolor: 'rgba(76, 175, 80, 0.05)' }}>
        <Typography variant="h4" gutterBottom>
          {t('herbtea.customService.title')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('herbtea.customService.description')}
        </Typography>
        
        <Grid container spacing={3} sx={{ mt: 2 }}>
          {Array.isArray(t('herbtea.customService.options', { returnObjects: true }))
            ? t('herbtea.customService.options', { returnObjects: true }).map((option, index) => (
              <Grid item xs={12} md={6} key={index}>
                <Card elevation={2}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {option.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                      {option.details}
                    </Typography>
                    <Typography variant="h6" color="primary.main">
                      {option.price}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))
            : <Grid item xs={12}><Typography>No custom service options available</Typography></Grid>
          }
        </Grid>
      </Paper>

     <Box sx={{ mb: 6 }}>
        <Typography variant="h4" gutterBottom>
          {t('herbtea.popularTeas.title')}
        </Typography>
        <Grid container spacing={3}>
          {Array.isArray(t('herbtea.popularTeas.teas', { returnObjects: true }))
            ? t('herbtea.popularTeas.teas', { returnObjects: true }).map((tea, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                 <Card elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                 <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    {/* Add tea image based on index */}
                    <Box 
                      component="img"
                      src={`/images/tea${index + 1}.png`}
                      alt={`Tea ${index + 1}`}
                      sx={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: '4px',
                        mb: 2
                      }}
                    />
                    <Typography variant="h6" gutterBottom>
                      {tea.name}
                    </Typography>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      <strong>{t('herbtea.ingredients')}:</strong>
                    </Typography>
                    <Typography variant="body2" paragraph>
                      {tea.ingredients}
                    </Typography>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      <strong>{t('herbtea.benefits1')}:</strong>
                    </Typography>
                    <Typography variant="body2">
                      {tea.benefits}
                    </Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    <Button
                      component="a"
                      href="https://www.paypal.com/ncp/payment/FGWQPWEAVZ9AL"
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="contained"
                      color="primary"
                      fullWidth
                      startIcon={<Payment />}
                      sx={{
                        mt: 2,
                        bgcolor: '#0070ba',
                        '&:hover': { bgcolor: '#005ea6' }
                      }}
                    >
                      10 Tea Packs for $80
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))
            : <Grid item xs={12}><Typography>No tea options available</Typography></Grid>
          }
        </Grid>
      </Box>

      <Paper elevation={3} sx={{ p: 4, bgcolor: 'rgba(76, 175, 80, 0.05)' }}>
        <Typography variant="h4" gutterBottom>
          {t('herbtea.pricing.title')}
        </Typography>
        <List>
          {Array.isArray(t('herbtea.pricing.options', { returnObjects: true }))
            ? t('herbtea.pricing.options', { returnObjects: true }).map((option, index) => (
              <ListItem key={index}>
                <ListItemText primary={option} />
              </ListItem>
            ))
            : <ListItem><ListItemText primary={t('herbtea.pricing.options')} /></ListItem>
          }
        </List>
        <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold', color: 'primary.main' }}>
          {t('herbtea.pricing.promotion')}
        </Typography>
      </Paper>
    </Container>
  );
};

export default HerbTea;